import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../store/ducks/admin.duck";
import { Button, Form, Row, Col } from "react-bootstrap";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, makeStyles } from "@material-ui/core";
import { format } from "date-fns";
import "../../_metronic/_assets/css/app2.css";
import "react-quill/dist/quill.snow.css";

export default function Notes(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchNotes({ type: "Client", pkID: props.clientID }));
  }, [dispatch, props.clientID]);

  const [bookingStatus, setBookingStatus] = useState(props.status ? props.status : "Active");
  const role = useSelector((state) => state.auth.roleDesc);
  const [newNote, setNewNote] = useState("");
  const [newAdditionalNote, setNewAdditionalNote] = useState("");
  const [notifyCentre, setNotifyCentre] = useState(false);
  const [additionalNoteError, setAdditionalNoteError] = useState("");
  const [attendanceError, setAttendanceError] = useState("");
  const [cancellationReasonError, setCancellationReasonError] = useState("");
  const [cancellationReason, setCancellationReason] = useState("");

  const notes = useSelector((state) => state.admin.Notes["Client"]);
  const onlyNotes = (notes || []).filter((note) => note.action === "Note");

  useEffect(() => {
    if (bookingStatus === "Active") {
      setNewNote("");
    } else {
      setNewNote(
        `${props.name} ${
          bookingStatus === "Attended"
            ? "attended their appointment at"
            : bookingStatus === "Rescheduled"
              ? "rescheduled"
              : cancellationReason === "NoShow"
                ? "did not attend their appointment at"
                : cancellationReason === "CancelledClient" || cancellationReason === "LateCancel"
                  ? "cancelled their appointment at"
                  : cancellationReason === "CancelledProvider" || cancellationReason === "LateCancelProvider"
                    ? "had their appointment cancelled it was scheduled for"
                    : ""
        } ${props.start ? format(new Date(props.start), "dd-MM-yyyy h:mm aa") : ""}`,
      );
    }
  }, [bookingStatus, cancellationReason, props.name, props.start]);

  // Automatically set booking status note depending on the status and cancellation reason selected by the user
  useEffect(() => {
    if (bookingStatus === "Active") {
      setNewNote("");
      return;
    }
    const formattedDate = props.start ? format(new Date(props.start), "dd-MM-yyyy h:mm aa") : "";

    let message = "";

    if (bookingStatus === "Attended") {
      message = `${props.name} attended their appointment at ${formattedDate}`;
    } else if (bookingStatus === "NoShow") {
      message = `${props.name} did not attend their appointment at ${formattedDate}`;
    } else if (bookingStatus === "Cancelled") {
      if (cancellationReason === "LateCancel") {
        message = `${props.name} cancelled their appointment within 48 hours at ${formattedDate}`;
      } else if (cancellationReason === "LateCancelProvider") {
        message = `${props.name}'s appointment was cancelled by the provider (within 48 hours), scheduled for ${formattedDate}`;
      } else {
        // default "Cancelled"
        message = `${props.name} appointment at ${formattedDate} was cancelled `;
      }
    }

    setNewNote(message);
  }, [bookingStatus, cancellationReason, props.name, props.start]);

  // Set notifiation flag automatically if the status is not active, attended or rescheduled
  useEffect(() => {
    if (bookingStatus !== "Active" && bookingStatus !== "Attended" && bookingStatus !== "Rescheduled") {
      setNotifyCentre(true);
    } else {
      setNotifyCentre(false);
    }
  }, [bookingStatus]);

  const getStatus = () => {
    if (bookingStatus === "Attended") return "MakeAttended";
    if (bookingStatus === "NoShow") return "NoShow";

    if (bookingStatus === "Cancelled") {
      if (cancellationReason === "LateCancel") return "LateCancel";
      if (cancellationReason === "LateCancelProvider") return "LateCancelProvider";
      return "Cancelled"; // default cancellation
    }

    return "Active";
  };

  function addNote() {
    // Determine if the criteria has been made
    var error = false;
    if (!newAdditionalNote?.trim()) {
      setAdditionalNoteError(
        "Please provide a brief note about the session and any agreed actions and next steps to share with the referring Medicare Mental Health Centre contact.",
      );
      error = true;
    } else {
      setAdditionalNoteError("");
    }
    if (bookingStatus === "Active") {
      setAttendanceError("Please select an attendance status.");
      error = true;
    } else {
      setAttendanceError("");
    }
    if ((bookingStatus === "Not Attended" || bookingStatus === "Cancelled") && cancellationReason === "") {
      setCancellationReasonError("Please select a reason for not attending.");
      error = true;
    } else {
      setCancellationReasonError("");
    }
    // Check no errors
    if (!error) {
      // Ok time to go - move from useState to FormData
      const formData = new FormData();
      let finalNote = newNote;

      // Add additional note to the main note body if it exists
      if (newAdditionalNote && newAdditionalNote.trim() !== "") {
        finalNote += `\n\nAdditional Note: ${newAdditionalNote}`;
      }
      // Add fields
      var noteBody = finalNote;
      formData.append("type", "Client");
      formData.append("pkid", props.clientID);
      formData.append("subject", "");
      formData.append("cc", "");
      formData.append("selector", "Note");
      formData.append("note", noteBody);
      formData.append("faxdestination", "");
      formData.append("faxFile", null);
      formData.append("existingFile", 0);
      formData.append("sendFormID", 0);
      formData.append("csNotifyPrimary", 0);
      formData.append("csNotifyAdmin", 0);
      formData.append("csNotifyProvider", 0);
      formData.append("csNotify", notifyCentre ? 1 : 0);
      // Ok Time to Dispatch
      process.env.REACT_APP_DEBUG && console.log(...formData);
      dispatch(Admin.actions.postNote({ formData: formData, type: "Client", pkID: props.clientID }));

      // console.log("Role:", role);

      // Also need to handle the booking updates
      // The refresh payload is interesting
      // if a psychologist and from props.source Calendar then refresh psychologist, if from List then refresh client for both the key and id
      // it is all good unless its admin in a calendar
      const psychologistRefresh = (role === "Psychologist" || role === "Admin") && (props.source === "Calendar" || props.source === "Approval");
      // Determine if we need to refresh the psychologist's view based on role and source
      dispatch(
        Admin.actions.putAppointment({
          id: props.bookingID,
          status: getStatus(),
          cancellationReason: newAdditionalNote,
          refreshPayload: {
            key: psychologistRefresh ? "psychologist" : "client",
            id: psychologistRefresh ? props.psychologistID : props.clientID,
          },
        }),
      );
      // Close Modal
      props.closeModal(false);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addNote();
  };

  const isWithin48Hours = () => {
    if (!props.start) return false;

    const now = new Date();
    const start = new Date(props.start);

    return start <= now || start - now <= 48 * 60 * 60 * 1000;
  };

  const within48Hours = isWithin48Hours();

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 200,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));

  const classes = useStyles();

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Form.Group as={Row} className="mb-3" controlId="client">
          <Form.Label column sm={3}>
            Client:
          </Form.Label>
          <Col sm={9}>
            <Form.Control plaintext readOnly defaultValue={props?.name || ""} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3" controlId="date">
          <Form.Label column sm={3}>
            Date:
          </Form.Label>
          <Col sm={9}>
            <Form.Control plaintext readOnly defaultValue={props?.start ? format(new Date(props.start), "dd-MM-yyyy") : ""} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3" controlId="time">
          <Form.Label column sm={3}>
            Time:
          </Form.Label>
          <Col sm={9}>
            <Form.Control plaintext readOnly defaultValue={props?.start ? format(new Date(props.start), "h:mm aa") : ""} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3" controlId="paymentType">
          <Form.Label column sm={3}>
            Payment Type:
          </Form.Label>
          <Col sm={9}>
            <Form.Control plaintext readOnly defaultValue={props?.paymentType || ""} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3" controlId="attendance">
          <Form.Label column sm={3}>
            Attendance:
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              as="select"
              value={bookingStatus || "Active"}
              onChange={(e) => setBookingStatus(e.target.value)}
              style={{ fontSize: "14px", width: "auto" }}
              isInvalid={!!attendanceError}
            >
              <option value="Active">Select Status</option>
              {props.attendanceStatus === "Past" && role === "Psychologist" ? <option value="Attended">Attended</option> : null}
              {props.attendanceStatus === "Past" && role === "Psychologist" ? <option value="NoShow">Did Not Attend</option> : null}
              <option value="Cancelled">Cancelled</option>
              {/* <option value="Rescheduled">Rescheduled</option> - need to understand this further */}
            </Form.Control>
            <Form.Control.Feedback type="invalid">{attendanceError}</Form.Control.Feedback>
          </Col>
        </Form.Group>
        {bookingStatus !== "Active" && bookingStatus !== "Attended" && bookingStatus !== "Rescheduled" && bookingStatus !== "NoShow" && (
          <Form.Group as={Row} className="mb-3" controlId="reason">
            <Form.Label column sm={3}>
              Cancelled Reason:
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                value={cancellationReason || ""}
                onChange={(e) => setCancellationReason(e.target.value)}
                style={{ fontSize: "14px", width: "auto" }}
                isInvalid={!!cancellationReasonError}
              >
                <option value="">Select a reason</option>
                {within48Hours && role === "Admin" && <option value="Cancelled">Cancellation</option>}
                {within48Hours && (
                  <>
                    <option value="LateCancel">Cancellation by Client (within 48 hours)</option>
                    <option value="LateCancelProvider">Cancellation by Provider (within 48 hours)</option>
                  </>
                )}
                {!within48Hours && <option value="Cancelled">Cancellation</option>}
              </Form.Control>
              <Form.Control.Feedback type="invalid">{cancellationReasonError}</Form.Control.Feedback>
            </Col>
          </Form.Group>
        )}
        <hr />
        <h4 className="mt-4 mb-4">Referring Centre and Provider Notes</h4>
        <h6 className="mb-5 text-muted">
          Provide a brief note about the session and any agreed actions and next steps to share with the referring Medicare Mental Health Centre contact.
        </h6>
        <Form.Group as={Row} className="mb-3" controlId="bookingNote">
          <Form.Label column sm={3}>
            Booking Note:
          </Form.Label>
          <Col sm={9}>
            <Form.Control as="textarea" disabled value={newNote || ""} rows={2} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3" controlId="additionalNote">
          <Form.Label column sm={3}>
            Additional Note:
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              as="textarea"
              rows={6}
              value={newAdditionalNote || ""}
              onChange={(e) => setNewAdditionalNote(e.target.value)}
              isInvalid={!!additionalNoteError}
            />
            <Form.Control.Feedback type="invalid">{additionalNoteError}</Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3 align-items-center" controlId="notifyCentre">
          <Form.Label column sm={3}>
            Notify Centre:
          </Form.Label>
          <Col sm={9}>
            <Form.Check type="checkbox" checked={notifyCentre} onChange={(event) => setNotifyCentre(event.target.checked)} />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label>Historical Notes</Form.Label>
          <TableContainer style={{ backgroundColor: "#FFF", height: 340, width: "100%", overflowY: "scroll" }}>
            <Table className={classes.table} aria-label="simple table" style={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 160, whiteSpace: "normal", wordBreak: "break-word" }}>Date</TableCell>
                  <TableCell style={{ width: 100, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>Source</TableCell>
                  <TableCell>Note</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {onlyNotes
                  ? onlyNotes.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            textAlign: "center",
                          }}
                        >
                          {format(new Date(row.createdOn), "dd-MM-yyyy")}
                          <br />
                          {format(new Date(row.createdOn), "HH:mm")}
                        </TableCell>
                        <TableCell style={{ width: 100, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>{row.createdBy}</TableCell>
                        <TableCell>{row.note}</TableCell>
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Form.Group>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
          <Button variant="secondary" onClick={() => props.closeModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </div>
      </Form>
    </>
  );
}
